import { Box, Grid, Typography } from '@mui/material';
import { UploadPhotoFormData } from 'modules/art';
import React, { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { CustomIcon } from 'shared/assets/icons';
import { ButtonWithIcon, FormUploadButton } from 'shared/components';
import { useLangContext } from 'shared/features/Language';
import { useAppUrlBuilderContext } from 'shared/tools';

export const UploadPhotoForm: FC<{ submit: (file: UploadPhotoFormData) => void }> = props => {
  const { submit } = props;
  const appUrlBuilder = useAppUrlBuilderContext();
  const { textData } = useLangContext();

  const form = useForm({
    mode: 'onChange',
    shouldFocusError: false,
    defaultValues: { newImage: null },
  });

  const formData = form.watch();

  useEffect(() => {
    if (formData.newImage) {
      form.handleSubmit(submit)();
    }
  }, [!!formData.newImage]);

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '18px',
      }}
    >
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{ flexDirection: 'column' }}
      >
        <Grid item>
          <FormUploadButton
            errorText="Select images"
            form={form}
            label={textData.uploadButton}
            fieldName="newImage"
          />
        </Grid>

        <Grid item>
          <Link to={appUrlBuilder.consumerVerify()}>
            <ButtonWithIcon
              type="button"
              icon={<CustomIcon name="arrowBottomLeftBlack" />}
              position="start"
              color="light"
            >
              <Typography
                variant="overline"
                sx={{
                  fontSize: { md: '24px', xs: '22px' },
                  margin: '0 20px',
                }}
              >
                {textData.buttonBack}
              </Typography>
            </ButtonWithIcon>
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};
